export default "__VITE_ASSET__bdc056b3__"